import { z } from 'zod';
/**
 * Consulta pública de CNPJ e CEP — o operador digita o documento e o cadastro
 * se preenche sozinho. É leitura, nunca gravação: quem decide o que entra no
 * cadastro continua sendo a tela.
 */
export const cnpjLookupSchema = z.object({
    document: z.string(),
    name: z.string(),
    tradeName: z.string().nullable(),
    /// Situação na Receita: ATIVA, BAIXADA, INAPTA, SUSPENSA…
    status: z.string().nullable(),
    isActive: z.boolean(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    zip: z.string().nullable(),
    street: z.string().nullable(),
    number: z.string().nullable(),
    complement: z.string().nullable(),
    district: z.string().nullable(),
    city: z.string().nullable(),
    uf: z.string().nullable(),
    mainActivity: z.string().nullable(),
    openedAt: z.string().nullable(),
});
export const cepLookupSchema = z.object({
    zip: z.string(),
    street: z.string().nullable(),
    district: z.string().nullable(),
    city: z.string().nullable(),
    uf: z.string().nullable(),
});
//# sourceMappingURL=lookup.js.map